'use strict';

exports.__esModule = true;

var _shallowEqual = require('fbjs/lib/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/recompose/shallowEqual.js
// module id = 233
// module chunks = 4